/* unplugin-vue-components disabled */import { render } from "./DeptListItem.vue?vue&type=template&id=cc503916&scoped=true&ts=true"
import script from "./DeptListItem.vue?vue&type=script&lang=ts"
export * from "./DeptListItem.vue?vue&type=script&lang=ts"

import "./DeptListItem.vue?vue&type=style&index=0&id=cc503916&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc503916"]])

export default __exports__